import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { isUUID } from "@/common/utils/orgRouteUtils";
import { Storage } from "@/common/utils/storage";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId",
)({
  params: {
    parse: (params: { organizationBusinessUnitId: string }) => {
      if (!isUUID(params.organizationBusinessUnitId)) {
        throw new Error("Invalid organizationBusinessUnitId");
      }
      return params;
    },
    stringify: (params: { organizationBusinessUnitId: string }) => params,
  },
  beforeLoad: async ({ params, context }) => {
    const { organizationBusinessUnitId } = params;
    const { organizations } = context as {
      organizations: {
        id: string;
        name: string;
        businessUnits: { id: string; name: string; permissions: string[] }[];
      }[];
    };

    const currentOrg = organizations?.find((org) =>
      org.businessUnits?.some((bu) => bu.id === organizationBusinessUnitId),
    );

    // A bookmarked or shared URL can outlive the business unit (removed, or the
    // user lost access). Send them to their own default business unit instead of
    // an error page; `/org` only redirects to units the user still belongs to.
    if (!currentOrg) {
      throw redirect({ to: "/org" });
    }

    const currentOrgBusinessUnit = currentOrg.businessUnits.find(
      (bu) => bu.id === organizationBusinessUnitId,
    );

    if (!currentOrgBusinessUnit) {
      throw redirect({ to: "/org" });
    }

    await Promise.all([
      Storage.setItem("selectedOrgId", currentOrg.id),
      Storage.setItem("selectedOrgBusinessUnitId", currentOrgBusinessUnit.id),
    ]);

    return {
      currentOrg,
      currentOrgBusinessUnit,
    };
  },
  component: () => <Outlet />,
});
